import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainTypeComponent } from '../components/main-type/main-type.component';
import { MainHomeComponent } from '../components/main-home/main-home.component';
import { TypeOrderComponent } from '../components/type-order/type-order.component';
import { TypeOrderItemComponent } from '../components/type-order-item/type-order-item.component';
import { SearchEdictComponent } from '../components/search-edict/search-edict.component';
import { OrderComponent } from './../components/order/order.component';
import { OrderItemComponent } from '../components/order-item/order-item.component';
import { SearchValidateEdictComponent } from '../components/search-validate-edict/search-validate-edict.component';
import { ValidateOrderComponent } from '../components/validate-order/validate-order.component';
import { MainReportComponent } from '../components/main-report/main-report.component';
import { AdminProductsComponent } from '../components/admin-products/admin-products.component';
import { ProductDetailComponent } from '../components/product-detail/product-detail.component';
import { AdminUsersComponent } from '../components/admin-users/admin-users.component';
import { AdminBranchesComponent } from '../components/admin-branches/admin-branches.component';
import { AdminRolesComponent } from '../components/admin-roles/admin-roles.component';
import { AdminUserDetailComponent } from './../components/admin-user-detail/admin-user-detail.component';
import { ProductNewComponent } from '../components/product-new/product-new.component';
import { MainPublishComponent } from '../components/main-publish/main-publish.component';
import { PublishEditionComponent } from '../components/publish-edition/publish-edition.component';
import { AuthGuardService } from '../services/auth-guard.service';
import { LoginComponent } from '../components/login/login.component';
import { ForbiddenComponent } from '../components/forbidden/forbidden.component';
import { NoAccessComponent } from '../components/no-access/no-access.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { LogoutComponent } from '../components/logout/logout.component';
import { AdminEditionsComponent } from './../components/admin-editions/admin-editions.component';
import { CertIndexComponent } from '../components/cert-index/cert-index.component';
import { CertDetailComponent } from '../components/cert-detail/cert-detail.component';

const routes: Routes = [
  { path: 'administrador/productos/nuevo', component: ProductNewComponent, canActivate: [AuthGuardService] },
  { path: 'administrador/productos/:code', component: ProductDetailComponent, canActivate: [AuthGuardService]},
  { path: 'administrador/productos', component: AdminProductsComponent, canActivate: [AuthGuardService]},
  { path: 'administrador/usuarios', component: AdminUsersComponent, canActivate: [AuthGuardService] },
  { path: 'administrador/usuarios:email', component: AdminUsersComponent, canActivate: [AuthGuardService] },
  { path: 'administrador/sucursales', component: AdminBranchesComponent, canActivate: [AuthGuardService]},
  { path: 'administrador/roles', component: AdminRolesComponent, canActivate: [AuthGuardService]},
  { path: 'administrador/ediciones', component: AdminEditionsComponent, canActivate: [AuthGuardService]},
  { path: 'certificaciones/:id', component: CertDetailComponent, canActivate: [AuthGuardService]},
  { path: 'certificaciones', component: CertIndexComponent, canActivate: [AuthGuardService]},
  { path: 'reportes', component: MainReportComponent, canActivate: [AuthGuardService]},
  { path: 'exportar/:id', component: PublishEditionComponent, canActivate: [AuthGuardService] },
  { path: 'exportar', component: MainPublishComponent, canActivate: [AuthGuardService] },
  { path: 'validar/:id', component: ValidateOrderComponent, canActivate: [AuthGuardService] },
  { path: 'validar', component: SearchValidateEdictComponent, canActivate: [AuthGuardService] },
  { path: 'digitar/:id/:line', component: TypeOrderItemComponent, canActivate: [AuthGuardService] },
  { path: 'digitar/:id', component: TypeOrderComponent, canActivate: [AuthGuardService] },
  { path: 'digitar', component: MainTypeComponent, canActivate: [AuthGuardService] },
  { path: 'buscar/:id/:line', component: OrderItemComponent, canActivate: [AuthGuardService]},
  { path: 'buscar/:id', component: OrderComponent, canActivate: [AuthGuardService] },
  { path: 'buscar', component: SearchEdictComponent, canActivate: [AuthGuardService] },
  { path: 'ingresar', component: LoginComponent },
  { path: 'no-autorizado', component: ForbiddenComponent },
  { path: 'sin-acceso', component: NoAccessComponent },
  { path: 'salir', component: LogoutComponent },
  { path: '', component: MainHomeComponent, canActivate: [AuthGuardService] },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
